<template>
  <div>
    <protective-gear-table :sortable="false" class="mt-2" @delete="detachProtectiveGear" @refresh="getUserProtectiveGear"
      icon="mdi-hard-hat"
      hide-search
      hide-subtitle
      hide-show-btn
      hide-edit-btn
      color="warning"
      :hide-actions="!hasRole(UserRoles.ADMIN)"
      :total="total"
      :items="userProtectiveGears"
      :pagination="pagination">
        <v-tooltip top slot="add" v-if="hasRole(UserRoles.ADMIN)">
          <v-btn slot="activator" small right fab dark color="tertiary lighten-1" @click.stop="openAttachProtectiveGearModal()">
            <v-icon dark>add</v-icon>
          </v-btn>
          <span>{{$t('Pages.Users.attach_protective_gear')}}</span>
        </v-tooltip>
    </protective-gear-table>
    <attach-protective-gear-modal @refresh="getUserProtectiveGear" v-model="showAttachProtectiveGearModal" :userId="this.$route.params.id" @close="showAttachProtectiveGearModal = false"></attach-protective-gear-modal>
  </div>
</template>

<script>
  import _ from 'lodash';
  import AttachProtectiveGearModal from './AttachProtectiveGearModal'
  import ProtectiveGearTable from '../protectiveGear/Table'
  import i18n from '@/i18n'
  export default {
  components: {AttachProtectiveGearModal, ProtectiveGearTable},
  data: () => ({
    showAttachProtectiveGearModal: false,
    userProtectiveGears: [],
    initial: true,
    total: 0,
    pagination: {},
  }),
  computed: {

  },
  created () {

  },
  methods: {
    getUserProtectiveGear(data = null){
      if(data) {
        this.pagination = data;
      }
      else{
        data = {};
      }
      if(this.initial){
        this.setFetching(true);
      }
      if(this.initial){
        this.setFetching(true);
      }
      // this.loading = true;
      // this.repositories.user.getPotectiveGear().then(response => {
      //   this.userProductSizes = response.data.data;
      //   this.total = response.data.meta.pagination.total;
      // }).finally(() => {
      //   this.loading = this.initial = false;
      //   this.setFetching(false);
      // });
    },
    openAttachProtectiveGearModal(){
      this.showAttachProtectiveGearModal = true;
    },
    detachProtectiveGear(item){
      // this.repositories.user.detachProtectiveGear().then((response) => {
      //   this.$toast.info(response.data.message);
      //   this.getUserProductSizes();
      // });
    },
  }
}
</script>

<style lang="scss">

</style>
